<template>
    <div class="">
        <VHeader>
        
        </VHeader>
        signing in...
        
    </div>
</template>

<script>
    import AWS from '@/resources/AWS.js';
    import {initPreload} from '@/api/apiServices';
    
    export default {
        name: 'SignedIn',
        created() {
            // if (!verification) {
            //   router.push({ name: 'error', params: { message: 'The authentication response did not contain a valid verification state value' } })
            //   return
            // }
            //
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            localStorage.code = code;
            AWS.getNewTokens()
                .then(() => {
                    // console.log('then');
                    const auth = async () => {
                        const lastPage = localStorage.getItem('lastPage');
                        const lastPageIsStage = localStorage.getItem('lastPageIsStage');
                        const pathToRedirect = lastPage ? lastPage : 'dashboard';
                        await initPreload();
                        if (lastPageIsStage) {
                            localStorage.removeItem('lastPageIsStage');
                            this.$router.push({path: pathToRedirect, query: {staging: lastPageIsStage}});
                        } else {
                            localStorage.removeItem('lastPageIsStage');
                            this.$router.push(pathToRedirect);
                        }
                    };
                    auth();
                })
                .catch(error => {
                    console.log(error.response);
                });
        },
    };
</script>